import { faFacebookSquare } from '@fortawesome/free-brands-svg-icons/faFacebookSquare';
import { faInstagram } from '@fortawesome/free-brands-svg-icons/faInstagram';
import { faTwitter } from '@fortawesome/free-brands-svg-icons/faTwitter';
import { faYoutube } from '@fortawesome/free-brands-svg-icons/faYoutube';
import React from 'react';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import Icon from '../../ui/Icon/Icon';
import Anchor from '../Anchor/Anchor';

const StyledSocialLinksList = styled.ul`
  display: flex;
  justify-content: center;
  position: relative;
  padding: 20px 0;
  margin: 20px -20px 0;
  border-top: 1px solid ${THEME.general.border};
  & > li > a {
    padding: 12px;
    margin: 0 6px;
  }
`;

const EXTERNAL_ANCHOR_ATTRS = {
  target: '_blank',
  rel: 'noopener noreferrer'
};

const SOCIAL_LINKS = [
  {
    href: 'https://www.facebook.com/maxpreps/',
    icon: faFacebookSquare
  },
  {
    href: 'https://twitter.com/MaxPreps',
    icon: faTwitter
  },
  {
    href: 'https://www.youtube.com/user/Maxprepssports',
    icon: faYoutube
  },
  {
    href: 'https://www.instagram.com/maxpreps/?hl=en',
    icon: faInstagram
  }
];

const HamburgerSocialLinks = () => (
  <StyledSocialLinksList>
    {SOCIAL_LINKS.map(link => (
      <li key={link.href}>
        <Anchor href={link.href} {...EXTERNAL_ANCHOR_ATTRS}>
          <Icon icon={link.icon} size={24} color={THEME.text.primary} />
        </Anchor>
      </li>
    ))}
  </StyledSocialLinksList>
);

export default HamburgerSocialLinks;
